module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get.3aa9f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_lets-get.png
// module id = XfkU
// module chunks = 0